export const BRAND = {
  shortName: '蓝鲸游动',
  productName: '蓝鲸游动企业邮箱',
  companyNameZh: '藍鯨游動科技有限公司',
  companyNameEn: 'BlueWhale Wander Tech Limited',
} as const
